import { DATA_TAG } from '../../theme/type.js';

/**
 * The warning board's two small controls, extracted on their third use.
 *
 * `MwView` and `RecognitionTable` had a byte-similar `CHIP` const each and
 * `TrackPanel` had a `LINK` that differed only in height — three copies of one
 * outlined chip, at `10.5px / .1em`, which is on no documented ramp. That is how
 * the type layer erodes: `theme/type.ts` was written to end exactly this and the
 * six MW files were edited a day later without importing it once.
 *
 * They are built from `DATA_TAG` rather than restating a face and a tracking,
 * so the next size correction happens in one place (M5-D3: extracted on second
 * use, never on speculation — this is the third).
 */

/** The 22px outlined chip: `TIMELINE`, `RECOGNITION`, `FILTERS`, `+ FILTER`. */
export const CHIP = {
  ...DATA_TAG,
  flex: 'none',
  height: 22,
  padding: '0 9px',
  background: 'transparent',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius)',
  color: 'var(--text-muted)',
  cursor: 'pointer',
} as const;

/** The same chip at 20px, for one sitting inside a field row rather than a band. */
export const CHIP_INLINE = {
  ...CHIP,
  height: 20,
  padding: '0 8px',
} as const;
